var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement, Children, Component } from 'react';
import classNames from 'classnames';
import Step from './Step';
export default class Steps extends Component {
    render() {
        const _a = this.props, { prefixCls, style = {}, className, children, direction, labelPlacement, iconPrefix, status, current, progressDot, initial, icons } = _a, restProps = __rest(_a, ["prefixCls", "style", "className", "children", "direction", "labelPlacement", "iconPrefix", "status", "current", "progressDot", "initial", "icons"]);
        const filteredChildren = React.Children.toArray(children).filter(c => !!c);
        const adjustedlabelPlacement = !!progressDot ? 'vertical' : labelPlacement;
        const classString = classNames(prefixCls, `${prefixCls}-${direction}`, className, {
            [`${prefixCls}-label-${adjustedlabelPlacement}`]: direction === 'horizontal',
            [`${prefixCls}-dot`]: !!progressDot,
        });
        return (<div className={classString} style={style} {...restProps}>
        {Children.map(filteredChildren, (child, index) => {
            if (!child) {
                return null;
            }
            const stepNumber = initial + index;
            const childProps = Object.assign({ stepNumber: `${stepNumber + 1}`, prefixCls,
                iconPrefix, wrapperStyle: style, progressDot,
                icons }, child.props);
            // fix tail color
            if (status === 'error' && index === current - 1) {
                childProps.className = `${prefixCls}-next-error`;
            }
            if (!child.props.status) {
                if (stepNumber === current) {
                    childProps.status = status;
                }
                else if (stepNumber < current) {
                    childProps.status = 'finish';
                }
                else {
                    childProps.status = 'wait';
                }
            }
            return cloneElement(child, childProps);
        })}
      </div>);
    }
}
Steps.Step = Step;
Steps.defaultProps = {
    prefixCls: 'cfm_steps',
    iconPrefix: 'cfm',
    direction: 'horizontal',
    labelPlacement: 'vertical',
    initial: 0,
    current: 0,
    status: 'process',
    progressDot: false,
};



// WEBPACK FOOTER //
// ./components/steps/Steps.tsx